<template>
    <div class="row">

      <div class="col-12 col-md-12 note-head">
        <div class="d-flex align-items-center">
          <h3 class="mb-0">{{ title }}</h3>
          <div class="ms-auto" v-if="hasHundredPercentResult">
            <div class="total-box" :class="totalStatusClass">
              <span class="label">Total</span>
              <span class="value">{{ totalNumericResult }}</span>
            </div>
          </div>
        </div>
      </div>

        <hr class="note-hr">

        <div class="col-12 col-md-12">
            <header>
                <slot name="header"></slot>
            </header>
        </div>

        <div v-if="isShowCardBody" class="col-12 col-md-12 note-body">
            <div class="card" :class="isBackground && 'note-bg'">
                <div class="card-body">
                    <main>
                        <slot></slot>
                    </main>
                </div>
            </div>
        </div>

        <div class="col-12 col-md-12">
            <footer>
                <slot name="footer"></slot>
            </footer>
        </div>

    </div>
</template>

<script setup>
import {computed} from "vue";

const props = defineProps({
    title: String,
    tableItems: {
      type: Array,
      default: []
    },
    isBackground: {
        type: Boolean,
        default: true,
    },
    isShowCardBody: {
        type: Boolean,
        default: true,
    },
})

const hasHundredPercentResult = computed(() => {
  return props.tableItems.some(
      item => item.is_hundred_percent_result_investigation === 1
  )
})

const isPureNumber = (value) => {
  return typeof value === 'number'
      || (typeof value === 'string' && value.trim() !== '' && !isNaN(value))
}

const totalNumericResult = computed(() => {
  return props.tableItems.reduce((sum, item) => {
    if (!isPureNumber(item.result)) return sum

    return sum + Number(item.result)
  }, 0)
})

const totalStatusClass = computed(() => {
  if (totalNumericResult.value === 100) {
    return 'total-box-success'
  }

  if (totalNumericResult.value > 100 || totalNumericResult.value < 100) {
    return 'total-box-danger'
  }

  return ''
})

</script>

<style scoped>
.note-hr{
    width: 90%;
    margin-left: 1%;
}
.note-body .card-body{
    padding: 2%;
    padding-top: 0;
}
.note-bg {
    background: #f9f9f9;
}
.note-body .card {
    min-height: 100px;
    margin-bottom: 1rem;
}
.medicine {
    display: flex;
    justify-content: space-between;
}

.total-box {
  padding: 6px 14px;
  border-radius: 6px;
  font-weight: 600;
  min-width: 110px;
  text-align: center;
  border: 1px solid transparent;
}

.total-box-success {
  background-color: #e6f4ea;
  color: #1e7e34;
  border-color: #1e7e34;
}

.total-box-danger {
  background-color: #fdecea;
  color: #b02a37;
  border-color: #b02a37;
}

.total-box .label {
  display: block;
  font-size: 12px;
  opacity: 0.8;
}

.total-box .value {
  font-size: 18px;
}

</style>